import produce, { castDraft, } from 'immer';
import { ProjectDevicesActionType, } from './actions';
const devicesByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case ProjectDevicesActionType.SET_PROJECT_DEVICES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const { devicesDataSet } = actualAction;
                // Add or replace devices in devicesById with the new list of devices
                devicesDataSet.items.forEach((device) => {
                    draft[device.id] = device;
                });
            });
        case ProjectDevicesActionType.SET_PROJECT_DEVICE:
            // When a project device is updated, we need to update the associated project device in the map of project devices by id
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.device.id] = actualAction.device;
            });
        default:
            return currentState;
    }
};
const deviceIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case ProjectDevicesActionType.SET_PROJECT_DEVICES:
            return produce(currentState, (draft) => {
                // actualAction.devicesDataSet contains the complete ProjectDevice data. However, we only need to save the list of device IDs
                // in draft[actualAction.projectId][actualAction.searchParams]
                const actualAction = action;
                const temp = draft[actualAction.projectId] || {};
                draft[actualAction.projectId] = temp;
                temp[actualAction.searchParams] = {
                    range: actualAction.devicesDataSet.range,
                    items: actualAction.devicesDataSet.items.map((device) => {
                        return device.id;
                    }),
                };
            });
        case ProjectDevicesActionType.CLEAR_PROJECT_DEVICES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
export const projectDevicesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.devicesById = devicesByIdReducer(currentState.devicesById, action);
        draft.deviceIdsByProjectId = castDraft(deviceIdsByProjectIdReducer(currentState.deviceIdsByProjectId, action));
    });
};
